import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import {
  WarehouseAreaServiceProxy,
  WarehouseLocationServiceProxy
} from '@/service-proxies/app-v2/warehouse.service-proxies'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'

const wasp = new WarehouseAreaServiceProxy()
const wlsp = new WarehouseLocationServiceProxy()
const crsp = new CodeRuleServiceProxy()

import {
  exportLocation,
  importLocation,
  exportLocationTemplate
} from '@/api/api'

@Component
export default class Location extends Template {
  @Prop({ default: '' }) readonly areaId: string // 库区
  @Prop({ default: null }) readonly changeLocation: any // 改变库位

  // 库位
  name = 'Location'
  options = {
    retrieve: wlsp.pageWarehouseLocation.bind(wlsp),
    search: wlsp.getWarehouseLocation.bind(wlsp),
    create: wlsp.createWarehouseLocation.bind(wlsp),
    update: wlsp.updateWarehouseLocation.bind(wlsp),
    delete: wlsp.deleteWarehouseLocation.bind(wlsp)
  }
  acl = {
    create: 'page_business_create_location',
    edit: 'page_business_edit_location',
    delete: 'page_business_delete_location'
  }

  hidden = ['delete']

  areaList = [] // 库区列表
  filterAreaList = [] // 库区列表
  // 当前库位所属的库区的本级标识 = 当前库位的父级标识
  pLevelNum = ''
  waitGetData = true
  scroll = { x: 1200, y: 300 }
  locationList = []
  disabled = false
  codeAreaId = ''
  areaName = ''
  importFilename = `${this.$t('page_business_reservoir_location')}.xlsx`
  exportFilename = `${this.$t('page_business_reservoir_location')}.xlsx`
  downloadFn = exportLocationTemplate
  importFn = importLocation
  exportFn = this.handleExport
  isBind = 0
  rowBind = 0

  get isBindList() {
    return [
      {
        label: this.$t('yes'),
        value: 1
      },
      {
        label: this.$t('no'),
        value: 0
      }
    ]
  }

  get lang() {
    return {
      create: this.$t('page_business_create_location'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      edit: this.$t('page_business_edit_location'),
      delete: this.$t('page_business_delete_location')
    }
  }

  async handleExport() {
    let a = this.areaId;
    if(this.areaId == '0') {
      a = "";
    }
    return await exportLocation(a)
  }

  @Watch('areaId')
  handleAreaIdChange(val) {
    this.getData()
  }

  @Watch('selectRowKey')
  handleSelectedRowKeysChange(val) {
    // console.log('选择库位：', val)
    this.changeLocation(val,this.rowBind)
  }

  @Watch('showDialog')
  handleDialogChange(val) {
    if (val) {
      this.getAreaList()
    }
  }

  @Watch('showDrawer')
  handleDrawerChange(val) {
    if (val) {
      this.getAreaList()
    }
  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    // this.selectRowKey = ''
    if (reload) current = 1
    const fetchFn = this.options.retrieve

    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      this.areaId,
      keyWords,
      size
    )
    records.map((item, index) => item.order = index + 1)
    const target = records.find(res => res.id === this.selectRowKey)
    if (!target) {
      if(records.length ){
        this.selectRowKey = records[0].id
        this.rowBind = records[0].isBind
      } else {
        this.selectRowKey = ''
      }
    }
    this.dataSource = records
    this.filters = {
      total: Number(t),
      size: Number(s),
      current: Number(c)
    }
  }
  async getCodeRules(){
    const res = await crsp.list('LocationObject')
    let arr = []
    arr = res
    for( const k of arr){
        this.locationList.push({
          label:k.name,
          value:k.id
        })
    }
  }
  created(){
    this.getCodeRules()
  }

  async handleChang(val) {
    if(val) {
      this.disabled = true
      await this._form_2.form.setFieldsValue({['code']:''})
    }else {
      this.disabled = false
    }
  }

  extraHeaderAction() {
    return [
      <import-button
        filename={this.importFilename}
        downloadFn={this.downloadFn}
        importFn={this.importFn}
        refresh={this.refresh}
        areaId={this.areaId}
        typeX='location'
        newResFlag={true}
        style="margin-left: 8px"
      />,
      <export-button
        simple
        filename={this.exportFilename}
        exportFn={this.exportFn}
        areaId={this.areaId}
        style="margin-left: 8px"
      />
    ]
  }

  render() {
    return this.customRender()
  }
  renderHeader() {
    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <a-button
            v-acl={this.acl.create}
            type="primary"
            style={{ marginRight: '8px' }}
            onClick={this.openCreateWindow}
          >
            {this.lang.create}
          </a-button>
          {this.ie ? this.extraHeaderAction() : null}
          <a-button
           style={{ marginLeft: "8px" }}
           disabled={this.selectedIds.length < 1}
           onClick={this.printing}
          >
             {this.$t('page_print_code')}
          </a-button>
          {this.extraHeaderAction()}
        </div>
        <div>
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
            style="width: auto!important;"
            v-model={this.keywords}
          ></a-input-search>
        </div>
      </div>
    )
  }
  printing() {
    this.getList()
    this.printVisible = true
  }

  cancel() {
    this.selectedRowKeys = []
    this.selectedIds = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.selectedIds = []
    this.printVisible = false
  }

  getList() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.dataSource.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.warehouseAreaCode,
            name: item.warehouseAreaName
          })
        }
      })
    })
  }
  renderPrint() {
      return (
        <code-model
          visible={this.printVisible}
          onCancel={this.cancel}
          dataList={this.dataList}
          onprint={this.handlerPrint}
          >
          </code-model>
        )
    }

  get columns() {
    return [
      {
        title: this.$t('page_tenant_operation'),
        key: 'action',
        fix: 'left',
        width: 100,
        customRender: (text, record) => {
          return (
            <div>
              <a
                href="javascript:;"
                onclick={() => this.editOperation(record)}
                v-acl={this.getAcl(this.acl.edit)}
              >
                {this.$t('edit')}
              </a>
              <a-divider type="vertical" v-acl={this.getAcl(this.acl.delete)}/>
              <a-popconfirm title={this.$t('page_resource_pool_confirm_delete')}
                            onConfirm={() => {
                              this.deleteSingleData([record.id])
                            }}
                            okText={this.$t('yes')}
                            cancelText={this.$t('no')}
              >
                <a class="del-color" v-acl={this.getAcl(this.acl.delete)}>
                  {this.$t('delete')}
                </a>
              </a-popconfirm>
            </div>
          )
        }
      },
      //序号
      {
        title: this.$t('page_mdc_setting_index'), dataIndex: 'order', width: 100, ellipsis: true
      },
      // 库区编码
      { title: this.$t('page_business_reservoir_code'), dataIndex: 'warehouseAreaCode', width: 100, ellipsis: true },
      // 库区名称
      { title: this.$t('page_business_reservoir_name'), dataIndex: 'warehouseAreaName', width: 100, ellipsis: true },
      // 本级标识
      { title: this.$t('page_business_level_identification'), dataIndex: 'levelNum', width: 100, ellipsis: true },
      // 父级标识
      { title: this.$t('page_business_parent_id'), dataIndex: 'plevelNum', width: 100, ellipsis: true },
      // 库位编码
      { title: this.$t('page_business_location_code'), dataIndex: 'warehouseLocationCode', width: 100, ellipsis: true },
      // 是否绑定物料
      {
        title: this.$t('page_business_weather_bind_material'), dataIndex: 'isBind', width: 100, ellipsis: true,
        customRender: (text) => text ? this.$t('yes') : this.$t('no')
      },
      // 库位名称
      { title: this.$t('page_business_location_name'), dataIndex: 'warehouseLocationName', width: 100, ellipsis: true },
      // 备注
      { title: this.$t('remark'), dataIndex: 'remark', width: 100, ellipsis: true }
    ]
  }

  get schema() {
    return {
      codeRuleId: {
        label: this.$t('page_system_coding_rules'),
        type: 'select',
        display:this.showDrawer?"none":"block",
        props: {
          allowClear: true,
          placeholder: this.$t('page_system_select_coding_rule'),
          maxLength: 128,
        },
        rules: [
          {
            message: this.$t('page_system_coding_rules')
          }
        ],
        options:this.locationList,
        on: {
          change: this.handleChang
        },
      },
      // 库位编码
      code: {
        label: this.$t('page_business_location_code'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_location_code'),
          // maxLength: 48,
          disabled: this.disabled || this.showDrawer
        },
        rules: [
          {
            required: !this.disabled,
            message: this.$t('page_business_enter_location_code')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      // 库位名称
      name: {
        label: this.$t('page_business_location_name'),
        type: 'input',
        props: {
          placeholder: this.$t('page_business_enter_location_name'),
          // maxLength: 48
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_enter_location_name')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      // 库区名称,实际传库区id
      areaId: {
        label: this.$t('page_business_reservoir_name'),
        type: 'select',
        props: {
          allowClear: true,
          placeholder: this.$t('page_business_select_reservoir'),
          disabled: this.showDrawer
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_select_reservoir')
          }
        ],
        defaultValue: this.areaId!=='0' ? this.areaId : '',
        options: this.filterAreaList,
        on: {
          change: this.getPLevelNum
        }
      },
      // 库区名称,实际传库区id
      isBind: {
        label: this.$t('page_business_bind_material'),
        type: 'select',
        props: {
          allowClear: false,
          placeholder: this.$t('page_business_select_bind_material')
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_select_bind_material')
          }
        ],
        defaultValue: this.isBind,
        options: this.isBindList,
        on: {
          change: this.changeCheck
        }
      },
      // 父级标识
      plevelNum: {
        label: this.$t('page_business_parent_id'),
        type: 'input',
        defaultValue: this.pLevelNum,
        props: {
          placeholder: this.$t('page_business_enter_parent_id'),
          // maxLength: 48,
          disabled: true
        },
        rules: [
          {
            required: true,
            message: this.$t('page_business_enter_parent_id')
          },
          { max: 48, message: this.$t('page_material_warehousing_custom_more48') }
        ]
      },
      remark: {
        label: this.$t('remark'),
        type: 'textarea',
        rows: 4,
        props: {
          placeholder: this.$t('remark_tips'),
          // maxLength: 252
        },
        rules: [
          { max: 252, message: this.$t('page_material_warehousing_custom_more252') }
        ]
      }
    }
  }

  editOperation(record){
    this.isBind = (record.isBind == null || record.isBind == undefined) ? 0 : record.isBind
    this.openEditWindow(record)
  }

  // 绑定物料修改
  changeCheck(value){
    if(this.isBind == 1 && value == 0) {
      this.$warning({
        title: this.$t('page_bill_settings_tip'),
        content: this.$t('page_material_warehousing_clean_tip'),
      });
    }
  }

  async getAreaList() {
    this.areaList = []
    this.filterAreaList = []
    this.areaList = await wasp.listWarehouseArea('')
    if (this.areaList && this.areaList.length) {
      this.filterAreaList = this.areaList.map((r) => ({
        label: r.name,
        value: r.id
      }))
      let temp = this.areaList.find(item => item.id === this.areaId)
      if (temp && temp.levelNum) {
        this.pLevelNum = temp.levelNum
      } else {
        this.pLevelNum = ''
      }
    }
  }

  async createData() {
    const data: any = await this._form_2.manualSubmit();
    let res = await wasp.listWarehouseArea('')
    let arr = res
    arr.map(item => {
      if(this.codeAreaId === item.id || this.areaId === item.id) {
        this.areaName =item.name
        data.areaName = this.areaName
      }
    })
    this.saveLoading = true;
    const fetchFn = this.options.create;

    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_create_success'))
      this.showDialog = false
      this.disabled = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  getPLevelNum(value) {
    if (this.areaList.length && value) {
      this.codeAreaId = value
      let temp = this.areaList.find(item => item.id === value)
      if (temp && temp.levelNum)
        this.pLevelNum = temp.levelNum
    } else if (!value) {
      this.pLevelNum = ''
    }
  }

  rowClick(record) {
    return {
      on: {
        click: (event: any) => {
          this.selectRowKey = record.id
          this.rowBind = record.isBind
          this.editdata = {}
        }
      }
    }
  }

}
